import "./Footer.scss";
import GetYear from "./GetYear";

function Footer() {
    return (
        <footer className="footer">
            <div className="wrapper">
                <div className="footer__blocks">
                    <div className="footer__block-hello">
                        <div className="footer__logo">
                            <a className="footer__logo-link link" href="https://www.pult.ru/">
                                <img className="footer__logo-img" src="/img/logo_pult.svg" alt="pult.ru" />
                            </a>
                        </div>
                        <div className="footer__call">
                            <a className="footer__tel link bold" href="tel:+78005555152" >8 (800) 555-51-52</a>
                            <p className="footer__call-text">Звонок по России бесплатный</p>
                        </div>
                    </div>
                    <ul className="footer__columns">
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/main/akustika/">Акустика</a>
                        </li>
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/main/hi-fi/">Hi-Fi</a>
                        </li>
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/main/vinil/">Винил</a>
                        </li>
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/main/naushniki/">Наушники</a>
                        </li>
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/main/televizory/">Телевизоры</a>
                        </li>
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/main/proektory/">Проекторы</a>
                        </li>
                    </ul>
                </div>
                <div className="footer__blocks">
                    <div className="footer__copyright">
                        <GetYear />
                    </div>
                    <ul className="footer__list">
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/main/akustika">О компании</a>
                        </li>
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/contacts/">Контакты</a>
                        </li>
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/contacts/">Салоны</a>
                        </li>
                        <li className="footer__list-item">
                            <a className="footer__link link" href="https://www.pult.ru/news/">Новости</a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>

    )
}
export default Footer;